module.exports = __webpack_public_path__ + "static/og-6c34cea75b53cce4c13725786ea6b89f.png";